import Tree from './Tree';
import TreeNode from './TreeNode';
Tree.TreeNode = TreeNode;

export { TreeNode };
export default Tree;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-tree/es/index.js
// module id = 275
// module chunks = 0 1